import { useSelector } from "react-redux";
import {
  hasAccessToModule,
  hasWritePermission,
  getPermissionType,
  type RolClave,
  type PermissionType,
} from "../utils/adminPermissions";

interface UseAdminPermissionResult {
  hasAccess: (moduleKey: string) => boolean;
  canWrite: (moduleKey: string) => boolean;
  getPermission: (moduleKey: string) => PermissionType;
  rolClave: RolClave | undefined;
}

/**
 * Hook para verificar permisos de usuario en el área de admin
 * @returns Objeto con funciones para verificar permisos
 */
export const useAdminPermission = (): UseAdminPermissionResult => {
  const authState = useSelector((state: any) => state.auth);
  const rolClave = authState.user?.rol?.clave as RolClave | undefined;

  return {
    hasAccess: (moduleKey: string) => hasAccessToModule(rolClave, moduleKey),
    canWrite: (moduleKey: string) => hasWritePermission(rolClave, moduleKey),
    getPermission: (moduleKey: string) => getPermissionType(rolClave, moduleKey),
    rolClave,
  };
};
